// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"603":"a5f2360f","868":"5b23bca6","895":"89474287","944":"0626f774"}[chunkId] + ".chunk.css";
};